import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.items?.length
    ? _c(
        _setup.CoreDialog,
        {
          attrs: {
            "data-qa": "lpu_photos_dialog",
            size: _setup.isMobile ? "fullscreen" : "xl",
            title: _setup.isMobile ? _setup.dialogTitle : undefined,
            divider: _setup.isMobile,
            "content-class": _setup.isMobile
              ? undefined
              : "lpu-photos-dialog-window",
            "slot-content-class": _setup.isMobile ? undefined : "py-8",
          },
          scopedSlots: _vm._u(
            [
              _setup.isMobile
                ? {
                    key: "prependBtn",
                    fn: function ({ btnProps }) {
                      return [
                        _c(
                          VBtn,
                          _vm._b(
                            {
                              on: {
                                click: function ($event) {
                                  _setup.isOpened = false
                                },
                              },
                            },
                            "v-btn",
                            btnProps,
                            false
                          ),
                          [
                            _c("span", {
                              staticClass: "ui-icon-close-not-a-circle",
                            }),
                          ]
                        ),
                      ]
                    },
                  }
                : null,
            ],
            null,
            true
          ),
          model: {
            value: _setup.isOpened,
            callback: function ($$v) {
              _setup.isOpened = $$v
            },
            expression: "isOpened",
          },
        },
        [
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "lpu-photos-dialog d-flex flex-column ga-4",
              class: {
                "lpu-photos-dialog--mobile flex-grow-1": _setup.isMobile,
              },
            },
            [
              _c(_setup.CoreSwiper, {
                ref: "swiperRef",
                staticClass: "lpu-photos-dialog__swiper",
                attrs: {
                  "initial-slide": _setup.initialSlide,
                  "slides-per-view": 1,
                  "space-between": 36,
                  "has-pagination": _setup.showPagination,
                  "has-navigation": _setup.showNavigation,
                  "auto-height": false,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "slides",
                      fn: function ({ slideAttrs }) {
                        return _vm._l(_vm.items, function (item, index) {
                          return _c(
                            "div",
                            _vm._b(
                              { key: `${item.id ?? item.src}-${index}` },
                              "div",
                              slideAttrs,
                              false
                            ),
                            [
                              _c("img", {
                                staticClass: "lpu-photos-dialog__image",
                                attrs: {
                                  src: item.src,
                                  alt: item.alt || item.title || "",
                                  "data-qa": "lpu_photos_dialog_image",
                                },
                              }),
                            ]
                          )
                        })
                      },
                    },
                  ],
                  null,
                  false,
                  3528719894
                ),
              }),
              _vm._v(" "),
              !_setup.isMobile
                ? _c(
                    "div",
                    {
                      staticClass:
                        "lpu-photos-dialog__meta d-flex flex-column align-center",
                    },
                    [
                      _setup.currentItem?.title
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "text-body-1 text--text align-self-stretch mb-0",
                              attrs: { "data-qa": "lpu_photos_dialog_title" },
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_setup.currentItem.title) +
                                  "\n      "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass:
                            "text-subtitle-2 text-secondary--text text-center mb-0",
                          attrs: { "data-qa": "lpu_photos_dialog_counter" },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.activeIndex + 1) +
                              " " +
                              _vm._s(_setup.tStatic("из")) +
                              " " +
                              _vm._s(_vm.items.length) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }